import React, { useState, useEffect } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, Table } from '@digital/ui';
import ComponeteCurso from '../../../components/componeteCurso';
import {
  ArquivoContratoAditivo,
  DeleteFileComentarioLinhaBmComAnexo,
  GetAllComentarioLinhaBmComAnexo,
  GetFileComentarioLinhaBmComAnexo,
  ViewFileComentarioLinhaBmComAnexo,
} from '../../../api/contrato/aditivosContrato';
import { GetFileExtension, getLoggedIsMRN, imageFormats } from '@app/helpers';
import { hasPermission } from '../../../helpers/permissions';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export interface PropsModalAnexo {
  linhaBmId: string;
  contemAnexo: boolean;
  usuarioLogadoGestorDoContratoFornecedor: boolean;
  usuarioLogadoFiscalDoContratoFornecedor: boolean;
  codStatusMedicao: number;
}

const ModalAnexo = (props: PropsModalAnexo) => {
  const {
    linhaBmId,
    contemAnexo,
    codStatusMedicao,
    usuarioLogadoFiscalDoContratoFornecedor,
    usuarioLogadoGestorDoContratoFornecedor,
  } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [dadosAnexo, setDadosAnexo] = useState<ArquivoContratoAditivo[]>([]);
  const [iconeAnexo, setIconeAnexo] = useState('');
  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  useEffect(() => {
    if (contemAnexo === true) {
      MudarIconeAnexo();
    }
  }, []);

  const MudarIconeAnexo = () => {
    setIconeAnexo('has-attachments');
  };

  const getAll = async () => {
    const result = await GetAllComentarioLinhaBmComAnexo(linhaBmId);
    if (result) setDadosAnexo(result);
  };

  const CarregarDados = () => {
    getAll();
  };

  const ObterArquivo = (id: string, nome: string) => {
    GetFileComentarioLinhaBmComAnexo(id, nome);
  };

  const ViewArquivo = (id: string, nome: string) => {
    ViewFileComentarioLinhaBmComAnexo(id, nome);
  };

  const DeleteAnexo = (id: string) => {
    DeleteFileComentarioLinhaBmComAnexo(id).then(result => {
      CarregarDados();
    });
  };

  const columns = [
    {
      title: 'Numero',
      dataIndex: 'numero',
      width: '10%',
    },
    {
      title: 'Nome',
      dataIndex: 'nome',
      width: '20%',
    },
    {
      title: 'Inclusão',
      dataIndex: 'createdAt',
      width: '20%',
      render : (text: any) => {
        return convertUTCtoLocal(moment(text)).toLocaleString();
      }
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      width: '20%',
    },
    {
      title: 'Ações',
      dataIndex: '',
      key: 'x',
      width: '5%',
      render: record => (
        <>
          {
            <>
              <Tooltip title="Baixar Arquivo">
                <Button
                  onClick={() => {
                    ObterArquivo(record.id, record.nome);
                  }}
                  icon="ui-download"
                  name="btnBaixarArquivo"
                />
              </Tooltip>
              {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    onClick={async () => {
                      await ViewArquivo(record.id, record.nome);
                    }}
                    icon="files-view_file"
                    name="btnViewArquivo"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {(isMRN ||
                ((codStatusMedicao === 1 || codStatusMedicao === 3) && // codigo 1 = Aguardando Forncedor    codigo 3 = Aguardando correção do fornecedor
                  (usuarioLogadoFiscalDoContratoFornecedor === true ||
                    usuarioLogadoGestorDoContratoFornecedor === true))) &&
              hasPermission(['MEDICAO_QUANTITATIVA_CADASTRAR_ANEXO']) ? (
                <Tooltip title="Excluir Anexo">
                  <Button
                    onClick={async () => {
                      await DeleteAnexo(record.id);
                    }}
                    icon="commons-delete"
                    name="btnDeleteArquivo"
                    confirm
                    okText="Excluir"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          }
        </>
      ),
    },
  ];

  return (
    <>
      <Tooltip title="Anexos">
        <Button
          onClick={() => {
            setExibirModal(true);
            CarregarDados();
          }}
          icon="messaging-attach"
          className={iconeAnexo}
        />
      </Tooltip>
      <Modal
        title="Anexos"
        className="chat-modal"
        width="800px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={[
          <Button
            key="submit"
            type="link"
            onClick={() => {
              setExibirModal(false);
            }}>
            Fechar
          </Button>,

          <>
            {(isMRN ||
              ((codStatusMedicao === 1 || codStatusMedicao === 3) && // codigo 1 = Aguardando Forncedor    codigo 3 = Aguardando correção do fornecedor
                (usuarioLogadoFiscalDoContratoFornecedor === true ||
                  usuarioLogadoGestorDoContratoFornecedor === true))) &&
            hasPermission(['MEDICAO_QUANTITATIVA_CADASTRAR_ANEXO']) ? (
              <ComponeteCurso
                id={linhaBmId}
                nomeIdFormulario={'anexoArquivoLinhaMedicaoId'}
                enderecoApi={'medicao/anexoArquivoLinhaMedicao'}
                descricaoBotao={'Adicionar Arquivo'}
                retorno={data => {
                  if (data.valid) {
                    CarregarDados();
                    MudarIconeAnexo();
                  }
                }}
                idDoComponente={`anexoLinhaBm_${linhaBmId}`}
              />
            ) : null}
          </>,
        ]}>
        <div className="all-padding">
          <Table dataSource={dadosAnexo} columns={columns} rowKey="id" pagination={false} />
        </div>
      </Modal>
    </>
  );
};

export default ModalAnexo;
